import axiosInstance from "./axios/axios_instance"
const http = axiosInstance("/public",  null, "/forbidden")

const getSectors = () => http.get("sectors");

export default {
    getSectors
}